// extracted by mini-css-extract-plugin
export default {"list":"ArticleList_list__O4UEE","elem":"ArticleList_elem__JGayG"};